import { render, staticRenderFns } from "./asset-form-core.vue?vue&type=template&id=b7a1612a&scoped=true&"
import script from "./asset-form-core.vue?vue&type=script&lang=js&"
export * from "./asset-form-core.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a1612a",
  null
  
)

export default component.exports